export class BasketItemRequest {  
  public areaId?: string;
  public ticketId: string;
  public quantity: number;  
  public date: string;
}

